export default "__VITE_ASSET__c2e11021__"